import { useQuery } from "@tanstack/react-query";
import { useServices } from "index";

export const useGetSignUpLists = () => {
  const profileService = useServices().profileService;
  return useQuery({
    queryKey: ['signUpLists'],
    queryFn: profileService.getSignUpLists,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};